import {AuthRepository} from "~/api/v2/auth/AuthRepository";
import {MissionRepository} from "~/api/v2/missions/MissionRepository";
import {UserRepository} from "~/api/v2/users/UserRepository";
import {MarketSegmentRepository} from "~/api/v2/market-segments/MarketSegmentRepository";
import {IndustryRepository} from "~/api/v2/industries/IndustryRepository";
import {ExperienceRepository} from "~/api/v2/experiences/ExperienceRepository";
import {ExportRepository} from "~/api/v2/export/ExportRepository";
import {CompanySizeRepository} from "~/api/v2/company-sizes/CompanySizeRepository";
import {DealSizeRepository} from "~/api/v2/deal-sizes/DealSizeRepository";
import {ExpertRepository} from "~/api/v2/experts/ExpertRepository";
import {PersonaRepository} from "~/api/v2/personas/PersonaRepository";
import {SkillRepository} from "~/api/v2/skills/SkillRepository";
import {PasswordRepository} from "~/api/v2/password/PasswordRepository";
import {ProfileRepository} from "~/api/v2/profile/ProfileRepository";
import {NextMissionRepository} from "~/api/v2/next-mission/NextMissionRepository";
import {MissionFeedbackRepository} from "~/api/v2/mission-feedback/MissionFeedbackRepository";
import {PageRepository} from "~/api/v2/workspace/PageRepository";
import {FileRepository} from "~/api/v2/files/FileRepository";
import type {$Fetch} from "nitropack";
import {InvoiceRepository} from "~/api/v2/invoices/InvoiceRepository";
import {CompanyDocumentRepository} from "~/api/v2/company/DocumentRepository";
import {BillingRepository} from "~/api/v2/billing/BillingRepository";
import {LinkedInRepository} from "~/api/v2/linkedin/LinkedInRepository";
import {TrackingRepository} from "~/api/v2/tracking/TrackingRepository";
import {MatchingWeightsRepository} from "~/api/v2/matching-weights/MatchingWeightsRepository";
import {BigScoreRepository} from "~/api/v2/big-score/BigScoreRepository";
import {ReferralRepository} from "~/api/v2/referrals/ReferralRepository";

const repositories = (client: $Fetch) => ({
    auth: AuthRepository(client),
    missions: MissionRepository(client),
    users: UserRepository(client),
    personas: PersonaRepository(client),
    marketSegments: MarketSegmentRepository(client),
    industries: IndustryRepository(client),
    invoices: InvoiceRepository(client),
    experiences: ExperienceRepository(client),
    export: ExportRepository(client),
    companySizes: CompanySizeRepository(client),
    dealSizes: DealSizeRepository(client),
    experts: ExpertRepository(client),
    skills: SkillRepository(client),
    tracking: TrackingRepository(client),
    password: PasswordRepository(client),
    mission_feedback: MissionFeedbackRepository(client),
    profile: ProfileRepository(client),
    nextMission: NextMissionRepository(client),
    workspacePage: PageRepository(client),
    file: FileRepository(client),
    requiredDocument: CompanyDocumentRepository(client),
    billing: BillingRepository(client),
    linkedin: LinkedInRepository(client),
    matchingWeights: MatchingWeightsRepository(client),
    bigScore: BigScoreRepository(client),
    referrals: ReferralRepository(client),
})

export default repositories;